import { createContext } from 'react';
import type { AuthContextProps } from '../Auth.types';
import type { ForgotPasswordResponse, ResetPasswordResponse } from '@/interfaces/api/app';
import { authInitialState } from './authInitialState';

const defaultContextValue: AuthContextProps = {
  ...authInitialState,
  login(): Promise<void> {
    throw new Error('login Function not implemented.');
  },
  logout(): Promise<void> {
    throw new Error('logout Function not implemented.');
  },
  setError(): void {
    throw new Error('setError Function not implemented.');
  },
  dispatch(): void {
    throw new Error('dispatch Function not implemented.');
  },
  clearStorage(): void {
    throw new Error('clearStorage Function not implemented.');
  },
  register(): Promise<void> {
    throw new Error('company registration Function not implemented.');
  },
  resetPassword(): Promise<ResetPasswordResponse> {
    throw new Error('resetPassword Function not implemented.');
  },
  forgotPassword(): Promise<ForgotPasswordResponse | undefined> {
    throw new Error('forgotPassword Function not implemented.');
  },
  /*   getProfile(): Promise<User | undefined> {
    throw new Error('getProfile Function not implemented.');
  }, */
  mutateUser(): Promise<void> {
    throw new Error('mutateUser Function not implemented.');
  },
  activateAccount(): Promise<void> {
    throw new Error('activateAccount Function not implemented.');
  },
};

const AuthContext = createContext<AuthContextProps>(defaultContextValue);

export default AuthContext;
